import { Skeleton } from 'antd'
import PlanCardSkeleton from './PlanCardSkeleton'

export default function PlansSkeleton() {
    return (
        <>
            <div className='text-center mb-8 flex flex-wrap justify-center'>
                <Skeleton.Input size='small' />
                <div className="w-full pt-3 px-32">
                    <Skeleton.Button size='small' block />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-6 overflow-x-auto">
                <PlanCardSkeleton />
                <PlanCardSkeleton />
            </div>
        </>
    )
}